import Login from '@/components/api/auth'

async function checkRefresh() {
  let show = false;
  const refreshToken = localStorage.getItem('refreshToken');
  if(refreshToken) {
    console.log('token あり');
    show = true;
    let res = await Login.refresh().then((val) => {
      if(!val) {
        console.log('tokenでログインできなかった');
        show = false;
      }
    });
  }

  return show;
}

async function checkRequestParam(url) {
  let bool = true;
  if(url) {
    console.log('コードあり');
    let res;
    // console.log('checkRequestParam 変数');
    // console.log(url);
    await Login.getToken(url).then((val) => { res = val; });
    // console.log('アクセストークンが取得できたか確認: '+res);
    if(!res) {
      console.log('コードあるけどトークン取得失敗');
      bool = false
    }
  } else {
    console.log('コードなし');
    bool = false;
  }
  return bool;
}

async function checkRequest(urlParam) {
  let res;
  let refresRes;
  await checkRequestParam(urlParam).then((val) => { res = val; });

  if(res) {
    return true;
  } else {
    console.log('codeは失敗したのでリフレッシュトークン使用する');
    const existRefreshToken = checkRefresh();
    await existRefreshToken.then((val) => { refresRes = val; });
    return refresRes; // true or false
  }

}

export default {
  checkRequest
}



// WEBPACK FOOTER //
// ./src/model/getToken.js